<template>
  <v-container grid-list-xl setReps>
    <v-layout row wrap>
      <v-data-table :headers="headers" :items="this.globalModalParams.vendorUsers" v-if="this.globalModalParams.vendorUsers.length != 0" class="elevation-1" hide-actions>
        <template slot="items" slot-scope="props">
          <td width="100%">{{ props.item }}</td>
        </template>
      </v-data-table>
      <p v-if="this.globalModalParams.vendorUsers.length == 0"><strong>No users were found.</strong></p>
      <div class="pl-4 pr-4 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
        headers: [
          { text: 'User', value: 'name', width: '100%' }
        ],
			};
		},
    methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'objUserInfo',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
